import React from "react";
import styles from "./styles.module.scss";

export const RadioButton = ({
    selected,
    dataTestId,
    value,
    children,
    onChange,
    disabled,
    theme,
}) => (
    <span className={styles.radioButton}>
        <label className={`${styles.box} ${disabled ? styles.disabled : ""}`}>
            <input
                checked={selected}
                value={value}
                onChange={onChange}
                type="radio"
                data-testid={dataTestId}
                disabled={disabled}
            />
            <span className={[styles.mark, styles[theme]].join(" ")} />
            {children}
        </label>
    </span>
);

export default ({ options, value, setter, disabled, checkIsDisabled, dataTestId, theme }) => (
    <React.Fragment>
        {options.map((opt, idx) => (
            <RadioButton
                key={idx}
                value={opt.value}
                selected={opt.value === value}
                onChange={(e) => setter(opt.value)}
                disabled={checkIsDisabled !== undefined ? checkIsDisabled(opt) : (disabled || opt.disabled)}
                dataTestId={`${dataTestId}-${opt.label}`}
                theme={theme}
            >
                {opt.label}
            </RadioButton>
        ))}
    </React.Fragment>
);
